import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import config from "./config"

Vue.use(Vuex);
var setFormData = function (data) {
  var params = new FormData();
  for (var key in data) {
    if (data[key] !== null && data[key] !== undefined) {
      params.append(key, data[key]);
    }
  }
  return params;
}
export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
    pageTitle: 'login',
    projectId: 0,
    edit: false,
    warning: {
      warningMsg: "",
      warningFalg: false,
      button: []
    },
    categoryListObj: {
      groupFalg: false,
      button: [],
    },
    subcategoryListObj: {
      groupFalg: false,
      id: "",
      button: [],
    },
    subpoiListObj: {
      groupFalg: false,
      button: [],
    },
    groupObj: {
      groupFalg: false,
      obj: {},
      button: [],
      index: "",
      objType: "",
    },
    poiListObj: {
      groupFalg: false,
      button: [],
    },
    eventListObj: {
      groupFalg: false,
      button: [],
    },
    language: [],
    refreshProject: false,
    changeMenu: false,
  },
  mutations: {
    setPageTitle(state, string) {
      state.pageTitle = string;
    },
    setwarning(state, data) {
      state.warning.warningMsg = data.string;
      state.warning.warningFalg = data.boolean;
      state.warning.button = data.button;
    },
    setgroup(state, data) {
      state.groupObj.obj = data.obj;
      state.groupObj.objType = data.objType;
      state.groupObj.altText = data.altText;
      state.groupObj.index = data.index;
      state.groupObj.groupFalg = data.boolean;
      state.groupObj.callback = data.callback;
    },
    setpoilist(state, data) {
      state.poiListObj.groupFalg = data.boolean;
      state.poiListObj.callback = data.callback;
      state.poiListObj.button = data.button;
    },
    seteventlist(state, data) {
      state.eventListObj.groupFalg = data.boolean;
      state.eventListObj.callback = data.callback;
      state.eventListObj.button = data.button;
      state.eventListObj.both = data.both;
      state.eventListObj.eventId = data.eventId;
    },
    login(state, userInfo) {
      Vue.set(state, 'userInfo', userInfo);
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    timeout(state, data) {
      console.log(config.globalMixin.langKey)
    }
  },
  getters: {
    warning: state => state.warning,
  },
  actions: {
    async preLogin(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data["apiUrl"];
          let result = await axios.post(`${config.domain}` + url, data, {
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (result.data.code === 0) {
            // result.data.payload.langCode="en_US";
            context.commit("login", result.data.payload);
            resolve(result);
          } else {
            context.commit("setwarning", {
              string: result.data.message,
              boolean: true,
              button: [
                {
                  name: "Cancel",
                  callBack: function () {
                    context.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
                  },
                },
              ],
            });
            resolve(false);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    async login(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data["apiUrl"];
          let result = await axios.post(`${config.domain}` + url, data, {
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (result.data.code === 0) {
            // result.data.payload.langCode="en_US";
            context.commit("login", result.data.payload);
          } 
          resolve(result);
        } catch (err) {
          reject(err);
        }
      });
    },
    async clientSystemLogin(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data['apiUrl']
          let result = await axios.get(`${config.domain}` + url, data, {
            headers: {
              'Content-Type': 'application/json',
            }
          });
          if (result.data.code === 0) {
            // result.data.payload.langCode="en_US";
            context.commit("login", result.data.payload);
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.message,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {
                  context.commit("setwarning", { string: "", boolean: false });
                }
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async apiEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data['apiUrl'];

          var domain = `${config.domain}`
          if (data.apiDomain) {
            domain = data.apiDomain;
            delete data['apiDomain'];
          }

          var Authorization = data.accessToken;

          delete data['accessToken'];
          if (data.geofenceData) {
            data = data.geofenceData;
          }
          let result = await axios.post(domain + url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${Authorization}`
            }
          })

          if (result.data.code === 0) {
            resolve(result)
          } else {
            context.commit("timeout", result.data);
            context.commit("setwarning", {
              string: result.data.message,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {
                  context.commit("setwarning", { string: "", boolean: false });
                }
              }]
            })
            if (result.data.code == 2002 || result.data.code == 2003) {
              resolve(2002)
            } else {
              resolve(false)
            }

          }
        }
        catch (err) {

          reject(err)
        }
      })
    },
    async apiGetEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        var Authorization = data.accessToken;

        delete data['accessToken'];
        let result = await axios.get(domain + url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${Authorization}`
          }
        })

        if (result.data.code === 0) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })
          if (result.data.code == 2002 || result.data.code == 2003) {
            resolve(2002)
          } else {
            resolve(false)
          }

        }
      })
    },
    async apiGetFileEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        var Authorization = data.accessToken;

        delete data['accessToken'];
        let result = await axios.get(domain + url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${Authorization}`
          },
          responseType: 'blob'
        })
        console.log(result)
        if (!result.data.code) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })
          if (result.data.code == 2002 || result.data.code == 2003) {
            resolve(2002)
          } else {
            resolve(false)
          }

        }
      })
    },
    async apiPostFileEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        var Authorization = data.accessToken;

        delete data['accessToken'];
        let result = await axios.post(domain + url, {},{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${Authorization}`
          },
          responseType: 'blob'
        })
        console.log(result)
        if (!result.data.code) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })
          if (result.data.code == 2002 || result.data.code == 2003) {
            resolve(2002)
          } else {
            resolve(false)
          }

        }
      })
    },
    async apiDeleteEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        var Authorization = data.accessToken;

        delete data['accessToken'];
        let result = await axios.delete(domain + url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${Authorization}`
          },
          data: data
        })

        if (result.data.code === 0) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })
          if (result.data.code == 2002 || result.data.code == 2003) {
            resolve(2002)
          } else {
            resolve(false)
          }

        }
      })
    },
    async apiPutEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        var Authorization = data.accessToken;

        delete data['accessToken'];
        let result = await axios.put(domain + url, data, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${Authorization}`
          }
        })

        if (result.data.code === 0) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })
          if (result.data.code == 2002 || result.data.code == 2003) {
            resolve(2002)
          } else {
            resolve(false)
          }

        }
      })
    },
    async apiEventFromData(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data['apiUrl'];

          var domain = `${config.domain}`
          if (data.apiDomain) {
            domain = data.apiDomain;
            delete data['apiDomain'];
          }
          var formData = "";
          if (data.files) {
            var files = data.files;
            delete data['files'];
            formData = setFormData(data)
            files.forEach((item, index) => {
              // data[`files[${index}]`] = item
              formData.append('files', item);
            })
          } else {
            formData = setFormData(data)
          }
          var Authorization = data.accessToken;

          delete data['accessToken'];
          let result = await axios.post(domain + url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `${Authorization}`
            }
          })

          if (result.data.code === 0) {
            resolve(result)
          } else {
            context.commit("timeout", result.data);
            context.commit("setwarning", {
              string: result.data.message,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {
                  context.commit("setwarning", { string: "", boolean: false });
                }
              }]
            })
            if (result.data.code == 2002 || result.data.code == 2003) {
              resolve(2002)
            } else {
              resolve(false)
            }

          }
        }
        catch (err) {

          reject(err)
        }
      })
    },
  },
  modules: {
  }
});
